import actionTypes from '../constants/action-types';

const siteId = (state = null, action) => {
  if (action.type !== actionTypes.SET_SITE_ID) return state;
  return action.payload.site.id;
};

export default siteId;
